import { SvgIcon } from '@mui/material';
import * as React from 'react';

export default function UnpinIcon({ ...props }) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.6 0.2V2.2H14.6V10.375L12.6 8.375V2.2H8.6V4.375L6.425 2.2L5.6 1.375V0.2H15.6ZM10.6 20.2L9.6 19.2V13.2H4.6V11.2L6.6 9.2V8.05L0 1.4L1.4 0L19.8 18.4L18.35 19.8L11.75 13.2H11.6V19.2L10.6 20.2ZM7.45 11.2H9.75L8.65 10.1L8.6 10.05L7.45 11.2Z"
          fill="black"
          fillOpacity="0.54"
        />
      </svg>
    </SvgIcon>
  );
}
